module.exports = __webpack_public_path__ + "media/3.96b1d684.mp3";